import React from 'react';

import './invalid-route.scss';

const ErrorPage = () => (
    <div className="error-page">
        <h1>Oops!</h1>
        <p>We seem to have a bit of a problem where we can't determine where to send you.</p>
    </div>
);

export default ErrorPage;
